import axios from "axios";
import { getApiHeaders } from "../../api/apiHeaders";
import alertify from 'alertifyjs';
import {
    // HISTORY_LIST_ATTEMPT,
    IMPORT_LIST_SUCCESS,
    IMPORT_LIST_FAILED,
    ////////////////////
    SET_IMPORT_TABLE
} from "../types/importTypes";
import { config } from "../../config";

const url_api = config.api.web;

export function setTable(data) {
    return {
        type: SET_IMPORT_TABLE,
        data: data
    };
}
///////////////////////
export function successNew(data) {
    return {
        type: IMPORT_LIST_SUCCESS,
        data: data
    };
}
export function failedNew(data) {
    return {
        type: IMPORT_LIST_FAILED,
        data: data
    };
}

export const setTableCSV = (data) => async (dispatch) => {
    dispatch(setTable(data));
};

export const newList = (data) => async (dispatch) => {
    try {
        const response = await axios({
            method: 'post',
            url: `${url_api}import/${data.params.broker}`,
            data: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            const body = response.data.body;
            const message = body?.message || 'import_success';
            dispatch(successNew(body));
            alertify.success(typeof message === 'string' ? message : 'OK');
            return { success: true };
        }
        dispatch(failedNew(response.data.body || 'try_later'));
        alertify.error(response.data.body || 'try_later');
        return { success: false };
    } catch (error) {
        const message = error.response?.data?.body || 'try_later';
        dispatch(failedNew(message));
        alertify.error(message);
        return { success: false };
    }
};